import { resolve } from "./relativeOffset.js";
const isPacking = (it) => "quantity" in it;
const resettable = (it) => it.provenance != null && it.provenance.createdByImport;
export function resetItemToImport(item, trip) {
    if (!resettable(item))
        return item;
    const snap = item.provenance.importedSnapshot;
    const provenance = { ...item.provenance, modifiedSinceImport: false };
    if (isPacking(item)) {
        const next = {
            id: item.id,
            categoryId: item.categoryId,
            name: snap.name,
            quantity: snap.quantity ?? item.quantity,
            ...optional("description", snap.description),
            ...optional("notes", snap.notes),
            // Tags are snapshot content, so they restore with the rest (T29). `staging` is
            // instance state and carries over from the live row (it was previously dropped).
            ...optional("tags", snap.tags),
            assignment: snap.assignment,
            completions: item.completions,
            ...optional("staging", item.staging),
            order: item.order,
            provenance,
            ...optional("templateIds", item.templateIds),
        };
        return next;
    }
    // todo: also restore the offset, re-resolve the due date from the trip start,
    // and clear the manual-override freeze so recompute tracks the trip again.
    let dueDate = trip?.startDate;
    if (snap.relativeDueOffset != null && trip?.startDate != null)
        dueDate = resolve(trip.startDate, snap.relativeDueOffset);
    const next = {
        id: item.id,
        categoryId: item.categoryId,
        name: snap.name,
        ...optional("description", snap.description),
        ...optional("notes", snap.notes),
        ...optional("tags", snap.tags), // snapshot content, restored like the name (T29)
        assignment: snap.assignment,
        completions: item.completions, // instance state is never touched by a reset
        ...optional("dueDate", dueDate),
        ...optional("relativeDueOffset", snap.relativeDueOffset),
        dueDateManuallyOverridden: false,
        remindersSentTo: item.remindersSentTo,
        reminderComplete: item.reminderComplete,
        order: item.order,
        provenance,
        ...optional("templateIds", item.templateIds),
    };
    return next;
}
// Include a key only when its value is defined (exactOptionalPropertyTypes).
const optional = (key, value) => value === undefined ? {} : { [key]: value };
//# sourceMappingURL=resetItemToImport.js.map